var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowRight_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m20.76 11.32-6.11-6.05c-.39-.39-1.02-.38-1.41 0-.39.39-.38 1.03 0 1.41l4.39 4.34H4c-.55 0-1 .45-1 1s.45 1 1 1h13.6l-4.32 4.23c-.39.39-.4 1.02-.02 1.41.2.2.46.3.71.3s.5-.09.7-.29l6.08-5.95a1 1 0 0 0 .3-.71 1 1 0 0 0-.3-.71z"
})));
export default SvgArrowRight;